// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"413baa11","363":"ce53e263","849":"6afce320","890":"b606f8eb"}[chunkId] + ".chunk.css";
};